import { message } from "antd";
import axios from "axios";
import {apiHeaders} from "../helper/apiHeader";
import startDashboard from "../helper/startDashboard";

export const loginApi = (value, dispatch, history) => {
  const { email, firstname, lastname, sch_code } = value;
  const data = {
    data: {
      email,
      firstname,
      lastname,
      sch_code,
      device_id: "",
    },
  };
  dispatch({ type: "LOGIN_LOADER" });
  axios
    .post("/UserProfile", data, apiHeaders("login"))
    .then((res) => {
      console.log("login data", res);
      if (res.data.status === "201") {
        dispatch({ type: "STUDENT_DATA", payload: res.data });
        startDashboard(history, res.data)
      } else if (res.data.status === "404B") {
        dispatch({ type: "MULTI_LOGIN", payload: res.data.msg });
      }
      else {
        message.error(res.data.msg);
        dispatch({ type: "LOGIN_ERR" });
      }
    })
    .catch((err) => {
      message.error(err);
      dispatch({ type: "LOGIN_ERR" });
    });
};

export const verifySchoolApi = (value, dispatch) => {
  const data = { data: { sch_code: value.sch_code } };
  dispatch({ type: "LOGIN_LOADER" });
  axios
    .post("/MetaData", data, apiHeaders("verifycode"))
    .then((res) => {
      if (res.data.status === "201") {
        dispatch({ type: "SCHOOL_DATA", payload: res.data });
      } else {
        message.error(res.data.msg);
        dispatch({ type: "LOGIN_ERR" });
      }
    })
    .catch((err) => {
      dispatch({ type: "LOGIN_ERR" });
    });
};

/* Support api : called on help support modal submit */

export const supportApi = (value, dispatch, player_id) => {
  const data = {
    data: {
      email: value.email,
      message: value.message,
      player_id: player_id || "0",
	  firstname: value.firstname,
	  lastname : value.lastname
    },
  };
  console.log("support request data", data);
  dispatch({ type: "LOGIN_LOADER" });

  axios
    .post("/MetaData", data, apiHeaders("contactsupport"))
    .then((res) => {
      console.log(res);
      if (res.data.status === "201") {
        dispatch({ type: "SUPPORT_DATA", payload: res.data });
      } else {
        message.error(res.data.msg);
        dispatch({ type: "SUPPORT_ERR" });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: "SUPPORT_ERR" });
    });
};